<template>
  <div style="min-width: 150px" v-clickOutside="close">
    <TimePicker
      class="caring-time-picker-picker"
      :open="open"
      :value="time"
      confirm
      :format="format"
      :style="{width: '100%', height: height + 'px'}"
      type="time"
      @on-change="handleChange"
      @on-clear="handleClear"
      @on-ok="handleOk"
    >
    </TimePicker>
    <div
      ref="refPicker"
      :class="[
        'caring-time-picker',
        'ivu-select',
        'ivu-select-multiple',
        'ivu-select-default',
      ]"
    >
      <div
        :class="[
          'ivu-select-selection',
          open ? 'ivu-select-selection-focused' : '',
        ]"
        tabindex="0"
        @click="openTimePicker"
      >
        <input
          type="hidden"
          name="caring-time-picker"
          value=""
        />
        <div style="overflow: hidden">
          <span
            v-if="!list.length"
            class="ivu-select-placeholder"
            style=""
            >请选择时间</span
          >
          <div
            class="ivu-tag ivu-tag-checked"
            v-for="item in list"
            :key="item.value"
          >
            <span class="ivu-tag-text">{{ item.label }}</span>
            <Icon type="ios-close" @click.native.stop="removeTag(item)"></Icon>
          </div>
        </div>
        <span class="caring-time-picker-calendar">
          <Icon type="ios-calendar-outline" />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import clickOutside from "../utils/directives/clickoutside";
export default {
  directives: { clickOutside },
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
    format: {
      type: String,
      default: "HH:mm"
    }
  },
  data() {
    return {
      open: false,
      time: "12:00",
      isFocused: false,
      list: [],
      height: 30
    };
  },
  watch: {
    dataSource(newVal) {
      this.list = newVal;
      this.dispatch('FormItem', 'on-form-change', this.list.length ? this.list[this.list.length - 1] : '');
      this.$nextTick(() => {
        this.height = this.$refs.refPicker.clientHeight;
      });
    },
    open(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.height = this.$refs.refPicker.clientHeight || 30;
        });
      }

    }
  },
  created() {
    this.list = this.dataSource
  },
  methods: {
    close() {
      this.open = false
    },
    dispatch(componentName, eventName, params) {
        let parent = this.$parent || this.$root;
        let name = parent.$options.name;

        while (parent && (!name || name !== componentName)) {
            parent = parent.$parent;

            if (parent) {
                name = parent.$options.name;
            }
        }
        if (parent) {
            parent.$emit.apply(parent, [eventName].concat(params));
        }
    },
    handleChange(time) {
      this.time = time;
    },
    handleClear() {
      this.open = false;
      this.dispatch('FormItem', 'on-form-change', this.list.length ? this.list[this.list.length - 1] : '')
    },
    handleOk() {
      if (!this.time) {
        this.$Message.warning("请不要提交空的时间");
      } else if (this.list.find((t) => t.label === this.time)) {
        this.$Message.warning("请不要提交已保存时间");
      } else {
        this.open = false;
        this.$emit("save", { label: this.time.slice(0, 5), value: this.time.length > 5 ? this.time : this.time + ':00' });
        this.dispatch('FormItem', 'on-form-change', this.time);
      }
    },
    toggleTimePicker() {
      this.open = !this.open;
    },
    openTimePicker() {
      this.open = true;
    },
    closeTimePicker() {
      this.open = false;
    },
    removeTag(item) {
      this.$emit("remove", item);
    },
    toggleFocus() {
      this.closeTimePicker();
    },
  },
};
</script>
<style lang="less">
.caring-time-picker {
  position: relative;
  &-calendar {
    position: absolute;
    top: 50%;
    right: 0;
    height: 30px;
    line-height: 30px;
    padding: 0 8px;
    transform: translateY(-50%);
  }
  &-picker {
    position: absolute;
    top: 0;
    left: 0;
    .ivu-date-picker-rel{
      height: 100%;
      .ivu-input-suffix{
        display: none;
      }
      .ivu-input{
        border: none;
        box-shadow: none;
      }
      .ivu-date-picker-focused input{
        border: none;
        box-shadow: none;
      }
    }
  }
}
</style>
